import { z } from 'zod';

export const displayNameSchema = z.string().min(2).max(25);
